import React, { MouseEvent } from 'react';
import TableWrapper from "../../../../components/TableWrapper";
import { Table, TableBody } from "@mui/material";
import PhotoUrlFactory from "../../../../../infrastructure/url-factory/PhotoUrlFactory";
import Pagination from "../../../../components/Pagination";
import { NumberishId } from "../../../../../model/type";
import DataTableRow from "./DataTableRow";
import DataTableHead from "./DataTableHead";
import { CopyTextToClipboard } from "../../../../../action/copyTextToClipboard";
import { OfferMedium } from "../../../../../model/OfferMedium";
import { UpdateManyAvailabilities } from "../../../../../action/updateManyAvailabilities";

const MediumsDataTable: React.FC<MediumsDataTableProps> = props => {
    const {
        selectedIds,
        paginatedOfferMediums,
        paginationProps,
        statusGetOfferMediums,
        sortableHeaderPropsFactory,
    } = props.context;


    return (
        <TableWrapper isLoading={ statusGetOfferMediums.pending() }>
            <Table>
                <DataTableHead
                    onCheckAllClick={ props.onCheckAllClick }
                    onUncheckAllClick={ props.onUncheckAllClick }
                    sortableTableHeaderPropsFactory={ sortableHeaderPropsFactory }
                />
                <TableBody>
                    {
                        paginatedOfferMediums?.records.map((medium) => (
                            <DataTableRow
                                key={ medium.mediumId }
                                medium={ medium }
                                photoUrlFactory={ props.photoUrlFactory }
                                selected={ selectedIds.includes(medium.mediumId) }
                                onRowClick={ props.onRowClick }
                                copyTextToClipboard={ props.copyTextToClipboard }
                                onEdit={ props.onEdit }
                                updateManyAvailabilities={ props.updateManyAvailabilities }
                            />
                        ))
                    }
                </TableBody>
            </Table>
            <Pagination { ...paginationProps }/>
        </TableWrapper>
    );
}
export default MediumsDataTable;

export interface MediumsDataTableProps {
    readonly photoUrlFactory: PhotoUrlFactory;
    readonly onCheckAllClick: () => void;
    readonly onUncheckAllClick: () => void;
    readonly onRowClick: (id: NumberishId, e: MouseEvent) => void;
    readonly copyTextToClipboard: CopyTextToClipboard;
    readonly context: {
        selectedIds: NumberishId[],
        paginatedOfferMediums: { records: OfferMedium[] } | undefined,
        paginationProps: any,
        statusGetOfferMediums: any,
        sortableHeaderPropsFactory: any,
    };
    readonly onEdit: () => void;
    readonly updateManyAvailabilities: UpdateManyAvailabilities;
}